import { BroadcastMessageTypeEnum } from 'app/models';

export class BroadcastMessageTypeModel {
    public static BroadcastMessageTypeList: Array<any> = [
        { name: 'Announcement', value: BroadcastMessageTypeEnum.Announcement },
        { name: 'Alert', value: BroadcastMessageTypeEnum.Alert },
        { name: 'Information', value: BroadcastMessageTypeEnum. Information },
        { name: 'Confirmation', value: BroadcastMessageTypeEnum.Confirmation },
        { name: 'Reminder', value: BroadcastMessageTypeEnum.Reminder },
        { name: 'Notification', value: BroadcastMessageTypeEnum.Notification },
        { name: 'Promotion', value: BroadcastMessageTypeEnum.Promotion },
        { name: 'Transaction', value: BroadcastMessageTypeEnum.Transaction },
        { name: 'Survey/Feedback', value: BroadcastMessageTypeEnum.SurveyFeedback },
        { name: 'Welcome', value: BroadcastMessageTypeEnum.Welcome },
        { name: 'Status Update', value: BroadcastMessageTypeEnum.StatusUpdate },
        { name: 'Error/Warning', value: BroadcastMessageTypeEnum.ErrorWarning },
        { name: 'Request', value: BroadcastMessageTypeEnum.Request },
        { name: 'Invitation', value: BroadcastMessageTypeEnum.Invitation },
        { name: 'Acknowledgement', value: BroadcastMessageTypeEnum.Acknowledgement },
        { name: 'Emergency', value: BroadcastMessageTypeEnum.Emergency },
        { name: 'Birthday/Greetings', value: BroadcastMessageTypeEnum.BirthdayGreetings },
        { name: 'News/Article', value: BroadcastMessageTypeEnum.NewsArticle },
        { name: 'System Update', value: BroadcastMessageTypeEnum.SystemUpdate },
    ];
}
